import React, { useState } from "react";
import { fetchWithAuth } from "../../../Context/UserContext";
import API_URL from "../../../config";
import { useNavigate, useLocation } from "react-router-dom";
import { LoadingOverlay } from "../../../components/ui/loading-overlay";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { toast } from "sonner";

const EliminarActivar = ({
  isOpen,
  onClose,
  idTender,
  estado,
  setSelectedTender,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Obtener la ruta actual

  // Función para manejar la acción del usuario
  const handleConfirm = async () => {
    if (!selectedOption) {
      toast.warning("Por favor selecciona una opción.");
      return;
    }

    setLoading(true);
    try {
      let url = "";
      let method = "";
      let successMessage = "";

      if (selectedOption === "desactivar") {
        url = `${API_URL}/licit/deactivate_tender/${idTender}`;
        method = "PUT";
        successMessage = "Licitación desactivada exitosamente.";
      } else if (selectedOption === "reactivar") {
        url = `${API_URL}/licit/reactivate_tender/${idTender}`;
        method = "PUT";
        successMessage = "Licitación reactivada exitosamente.";
      } else if (selectedOption === "eliminar") {
        url = `${API_URL}/licit/delete_tender/${idTender}`;
        method = "DELETE";
        successMessage = "Licitación eliminada exitosamente.";
      }

      const response = await fetchWithAuth(url, { method });

      if (response.ok) {
        toast.success(successMessage);
        if (selectedOption === "eliminar") {
          onClose(); // Cerrar modal
          if (location.pathname === "/mis-licitaciones") {
            window.location.reload(); // 🔹 Recargar si ya estamos en la página
          } else {
            navigate("/mis-licitaciones"); // 🔹 Redirigir si estamos en otra ruta
          }
        } else {
          setSelectedTender((prev) => ({
            ...prev,
            estado: selectedOption === "desactivar" ? "Inactivo" : "Activo",
          }));
          onClose();
        }
      } else {
        toast.error("Error al procesar la acción.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Ocurrió un error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        {loading && <LoadingOverlay />}
        <DialogHeader>
          <DialogTitle>
            {estado === "Activo"
              ? "Eliminar licitación"
              : estado === "Inactivo"
              ? "Reactivar licitación"
              : "Eliminar licitación permanentemente"}
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">
          {estado === "Activo"
            ? "Puedes desactivar esta licitación para que no sea visible, o eliminarla permanentemente."
            : estado === "Inactivo"
            ? "Puedes reactivar esta licitación o eliminarla de manera permanente."
            : "Puedes eliminar esta licitación, pero ya después no podrás reusarla luego."}
        </p>

        <div className="space-y-3">
          {estado === "Activo" && (
            <>
              <label className="flex items-start gap-2 text-sm">
                <input
                  type="radio"
                  name="action"
                  value="desactivar"
                  onChange={() => setSelectedOption("desactivar")}
                  className="mt-1"
                />
                Desactivar - La licitación quedará oculta y no podrá recibir postulaciones.
              </label>
              <label className="flex items-start gap-2 text-sm">
                <input
                  type="radio"
                  name="action"
                  value="eliminar"
                  onChange={() => setSelectedOption("eliminar")}
                  className="mt-1"
                />
                <span>
                  <strong className="text-destructive">Eliminar</strong> - Esta acción es{" "}
                  <strong className="text-destructive">irreversible</strong> y eliminará la licitación y sus
                  datos asociados.
                </span>
              </label>
            </>
          )}

          {estado === "Inactivo" && (
            <>
              <label className="flex items-start gap-2 text-sm">
                <input
                  type="radio"
                  name="action"
                  value="reactivar"
                  onChange={() => setSelectedOption("reactivar")}
                  className="mt-1"
                />
                Reactivar - La licitación volverá a estar visible y abierta a postulaciones.
              </label>
              <label className="flex items-start gap-2 text-sm text-destructive">
                <input
                  type="radio"
                  name="action"
                  value="eliminar"
                  onChange={() => setSelectedOption("eliminar")}
                  className="mt-1"
                />
                <strong>Eliminar - Esta acción es IRREVERSIBLE y eliminará la licitación y sus datos asociados.</strong>
              </label>
            </>
          )}

          {estado === "licitacion-ganada" && (
            <label className="flex items-start gap-2 text-sm text-destructive">
              <input
                type="radio"
                name="action"
                value="eliminar"
                onChange={() => setSelectedOption("eliminar")}
                className="mt-1"
              />
              <strong>Eliminar - Esta acción es IRREVERSIBLE y eliminará la licitación y sus datos asociados.</strong>
            </label>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cerrar
          </Button>
          <Button variant="destructive" onClick={handleConfirm} disabled={loading}>
            {loading ? "Procesando..." : "Confirmar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EliminarActivar;
